import loadScript from '@@/js/utils/load-script';
import { removeClasses } from '@@/js/utils/remove-classes';

const form = document.querySelector('[data-form]');

export class DiscoverChildcare {
  constructor() {

    this.$enquiry_el = $('[data-form="enquiry"]');
    this.$enrol_el = $('[data-form="enrol"]');

    if (this.$enquiry_el.length) {
      this.init_enquiry();
    }

    if (this.$enrol_el.length) {
      this.init_enrol();
    }
  }

  init_enquiry() {
    const $el = this.$enquiry_el;

    $.ajax({
      // url: `https://api.discoverchildcare.co.nz/api/Enquiry?t=${$el.data('api-key')}`,
      url: `https://api.discoverchildcare.co.nz/api/Enquiry?t=${$el.data('api-key')}&version=2&ExcludeJQueryLibrary=true`,
      success: (data) => {
        $el.html(null);
        $el.html(data);

        // add shadow dom vanilla js
        // const iframe = document.createElement('iframe');
        // $el.html(iframe);

        // copy current <head> to iframe
        // const head = document.head;
        // const iframeHead = iframe.contentDocument.head;
        // for (let i = 0; i < head.children.length; i++) {
        //   iframeHead.appendChild(head.children[i].cloneNode(true));
        // }
        //
        // const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        // iframeDoc.open();
        // iframeDoc.write(data);
        // iframeDoc.close();


        // const shadow = form.attachShadow({ mode: "open" })
        // const div = document.createElement("div");
        // div.innerHTML = data;
        //
        // shadow.appendChild(div);





        // we want to add custom classes instead of the generic ones
        // this.clean_classes($el);
        // this.hide_additional_checkboxes($el);
      },
      error: (data) => {
        $el.html("Sorry, our web enquiries form is unavailable at this time please check again shortly.");
      },
    });
  }

  init_enrol() {
    const $el = this.$enrol_el;

    this.loadGoogleMaps()
    .then(() => this.loadDcWidget())
    .then(() => {
      $.ajax({
        // url: `https://api.discoverchildcare.co.nz/api/OnlineApplication?token=${$el.data('api-key')}&noCSS=true`,
        url: `https://api.discoverchildcare.co.nz/api/OnlineApplication?token=${$el.data('api-key')}&version=3&ExcludeJQueryLibrary=true`,
        success: (data) => {
          $el.html(null);
          $el.html(data);

          // we want to add custom classes instead of the generic ones
          // this.clean_classes($el)

          // this.clean_enrol_classes($el);

        },
        error: (data) => {
          $el.html("Sorry, our web enrolment form is unavailable at this time, please check again shortly.");
        },
      });
    });
  }

  hide_additional_checkboxes($el) {
    $el.find('.IsToiletTrained').closest('.row').addClass('hidden').hide();
  }

  clean_classes($el) {
    // add classes for select's parents

    // $el.find('select.form-control').each(function (k, el) {
    //   $(el).parent().addClass('select-container');
    // });


    // const $cols = $el.find('.row > div');
    // removeClasses($cols, ['col-']);
    // $cols.addClass('clmn');

    // $('.form-actions').removeClass('row');


    // $el.find('.form-group > div').each(function () {
    //   const $el = $(this);
    //
    //
    //   removeClasses($(this), ['col-']);
    //
    //
    //   if ($el.find('select.inline-auto-width').length) {
    //     // $el.addClass('inline-container')
    //     $el.removeClass('select-container')
    //     .removeClass('text-align-left').addClass('select-container-wrap');
    //
    //     $el.find('select').wrap('<div class="select-inline"></div>');
    //
    //   } else if ($el.find('label').length) {
    //     $el.addClass('label-container');
    //   } else if ($el.find('.form-control').length) {
    //     $el.addClass('control-container');
    //   }
    //
    //
    // });
  }

  loadDcWidget() {
    const promise = new Promise((resolve) => {
      loadScript(`https://api.discoverchildcare.co.nz/application/onlinewidgetV2?v=2`, () => {
        resolve(true);
      });
    });

    return promise;
  }

  loadGoogleMaps() {
    const promise = new Promise((resolve) => {
      loadScript(`https://maps.googleapis.com/maps/api/js?key=AIzaSyCd8PxMtYjP7bnThDcGIC_gqtnn_THRcBo&libraries=places&sensor=false`, () => {
        resolve(true);
      });
    });

    return promise;
  }


  clean_enrol_classes($el) {

    // const $actions = $('.actions')
    //
    // console.log($actions)
    // console.log($actions.find('a[href*=cancel]'))
    //

    // const $form_groups = $el.find('.row .form-group')

    // $form_groups.each((k, el) => {
    //   const $form = $(el)
    //   $form.find('.col-1,.col-2').wrapAll("<div class='form-section' />")
    //   $form.find('.col-3,.col-4').wrapAll("<div class='form-section' />")
    // })

  }


}

new DiscoverChildcare();
